module["exports"] = [
  "#####",
  "#####-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/postcode.js
// module id = 1260
// module chunks = 0